import { Dialog, IDialogProps } from "@bps/fluent-ui";

import { BpIdInviteAuditLogList } from "./BpIdInviteAuditLogList";

interface BpIdinviteAuditLogDialogProps extends IDialogProps {
  onDismiss: () => void;
  invitationId?: string;
}

export const BpIdinviteAuditLogDialog: React.FC<BpIdinviteAuditLogDialogProps> = ({
  invitationId,
  ...props
}) =>
  invitationId ? (
    <Dialog
      hidden={false}
      minWidth="80%"
      dialogContentProps={{
        showCloseButton: true,
        title: "Invitation Audit Log"
      }}
      {...props}
    >
      <BpIdInviteAuditLogList invitationId={invitationId} />
    </Dialog>
  ) : null;
